import React from 'react'
import {Job} from '@/generated/graphql'
import { TableCell} from '@mui/material'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import {shortenDate} from '@/utils/dateUtils'
import MuiTableContainer from '@/components/common/MuiTableContainer'
import AppliedDatasetFilterDialog from '@/components/common/AppliedDatasetFilterDialog'
import DatasetJobTableItemActions from '@/components/pages/JobsPage/DatasetJobTableItemActions'
import { StyledTableHeader } from '@/components/common/CustomStyledComponents'

type DatasetTableProps = {
    jobs: Job[]
}

const DatasetTable = ({jobs}: DatasetTableProps) => {
    const [selectedJob, setSelectedJob] = React.useState<Job | undefined>(undefined)
    
    return (
        <>
            <MuiTableContainer maxHeight='70vh'>
                <TableHead>
                    <TableRow>
                        <StyledTableHeader>Id</StyledTableHeader>
                        <StyledTableHeader>Dataset id</StyledTableHeader>
                        <StyledTableHeader>Dataset name</StyledTableHeader>
                        <StyledTableHeader>Dataset description</StyledTableHeader>
                        <StyledTableHeader>Number of samples</StyledTableHeader>
                        <StyledTableHeader>State</StyledTableHeader>
                        <StyledTableHeader>Start date</StyledTableHeader>
                        <StyledTableHeader>End date</StyledTableHeader>
                        <StyledTableHeader>Actions</StyledTableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {jobs.map((job: Job, idx) => (
                        <TableRow key={job.id + '-' + idx}>
                            <TableCell>{job.id}</TableCell>
                            <TableCell>{job.dataset_id}</TableCell>
                            <TableCell>{job.dataset_name}</TableCell>
                            <TableCell>{job.dataset_description}</TableCell>
                            <TableCell align="center">{job.num_of_samples}</TableCell>
                            <TableCell>{job.state}</TableCell>
                            <TableCell>{shortenDate(job.start_date)}</TableCell>
                            <TableCell>{shortenDate(job.end_date)}</TableCell>
                            <TableCell>
                                <DatasetJobTableItemActions datasetJob={job} onShowFilter={(datasetJob) => setSelectedJob(datasetJob)} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </MuiTableContainer>
            <AppliedDatasetFilterDialog open={!!selectedJob} onClose={() => setSelectedJob(undefined)} dataset={selectedJob} />
        </>
    )
}

export default DatasetTable